import { toast } from 'sonner'
import {
  FROZEN_DELETE_MESSAGE,
  FROZEN_DELETE_TOAST_DURATION_MS,
  FROZEN_GROUP_CHILD_DELETE_MESSAGE,
} from '@/lib/editor/freeze-object-messages'

/** Delete/Cut refused because the selection itself is frozen: pulse the chrome and say why. */
export function notifyFrozenDeleteBlocked(pulseSelectionGeometryBlocked: () => void): void {
  pulseSelectionGeometryBlocked()
  toast.error(FROZEN_DELETE_MESSAGE, {
    duration: FROZEN_DELETE_TOAST_DURATION_MS,
    position: 'top-right',
  })
}

/** Delete/Cut refused inside group isolation because a child sits under a frozen group. */
export function notifyFrozenGroupChildDeleteBlocked(
  pulseSelectionGeometryBlocked: () => void
): void {
  pulseSelectionGeometryBlocked()
  toast.error(FROZEN_GROUP_CHILD_DELETE_MESSAGE)
}
